export {};

interface GTMDataLayer {
	[key: string]: unknown;
}
interface BatteryManager extends EventTarget {
	readonly charging: boolean;
	readonly level: number;
}

declare global {
	interface Window {
		dataLayer: GTMDataLayer[];
		showBatteryLowMessage: () => void;
	}
	interface Navigator {
		getBattery?: () => Promise<BatteryManager>;
	}
}

const storageName = 'batteryWarning',
	batteryThreshold = 0.12, // = 12 %
	batteryCheckDelayInSeconds = 20,
	closeToggleDelayInSeconds = 1.5;

let batteryCheckInterval: ReturnType<typeof setInterval>;
let batteryHasEventListener = false;

const elements = {
	batteryModal: () => document.querySelector<HTMLElement>('#battery-low'),
	batteryCloser: () => document.querySelector<HTMLElement>('#battery-low header button'),
	batteryToggle: () => document.querySelector<HTMLElement>('#battery-low footer .form-binary-input'),
};

const batteryModal = elements.batteryModal();
const batteryCloser = elements.batteryCloser();
const batteryToggle = elements.batteryToggle();

if (!batteryModal || !batteryCloser) {
	throw new Error('Battery modal elements are missing');
}

const classNames = {
	show: 'battery--show',
};

const isVisible = (): boolean => batteryModal.classList.contains(classNames.show);

const show = () => {
	if (isVisible()) {
		return;
	}
	batteryModal.classList.add(classNames.show);

	// Send event to data layer
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'lowBatteryShow',
	});
};

const hide = (continueChecking = false) => {
	if (!continueChecking) {
		clearInterval(batteryCheckInterval);
	}
	batteryModal.classList.remove(classNames.show);
};

const checkBatteryStatus = () => {
	if (!navigator.getBattery) return;

	navigator
		.getBattery()
		.then((battery) => {
			if (!battery.charging && battery.level < batteryThreshold) {
				show();

				if (!batteryHasEventListener) {
					battery.addEventListener('chargingchange', () => {
						if (battery.charging && isVisible()) {
							hide(true);
						}
					});
					batteryHasEventListener = true;
				}
			}
		})
		.catch((error: Error) => {
			console.error('Battery status check failed', error);
			clearInterval(batteryCheckInterval);
		});
};

const runBatteryCheck = () => {
	if (navigator.getBattery && !localStorage.getItem(storageName) && !sessionStorage.getItem(storageName)) {
		batteryCheckInterval = setInterval(checkBatteryStatus, batteryCheckDelayInSeconds * 1000);
	}
};

/**
 * Closing the battery warning
 */

// 1. When the close button is clicked the battery warning should be hidden and not shown again for the current session
batteryCloser.addEventListener('click', () => {
	sessionStorage.setItem(storageName, String(false));
	hide();
});

// 2. When the toggle is clicked the battery warning should be hidden and not shown again as long as the local storage is not cleared
batteryToggle?.addEventListener('change', () => {
	setTimeout(() => {
		localStorage.setItem(storageName, String(false));
		hide();
	}, closeToggleDelayInSeconds * 1000);
});

runBatteryCheck();

// Expose function to show battery warning message
window.showBatteryLowMessage = show;
